import { render } from "./SectionSpecificFilter.vue?vue&type=template&id=34448c4b"
import script from "./SectionSpecificFilter.vue?vue&type=script&lang=js"
export * from "./SectionSpecificFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__